module.exports = __webpack_public_path__ + "static/media/jeopardy.2c990e0b.png";